import { Pause, PlayArrow } from '@mui/icons-material';
import { Box, IconButton, Paper, Slider, Stack, styled } from '@mui/material';
import {
	EventHandler,
	ReactEventHandler,
	useEffect,
	useLayoutEffect,
	useRef,
	useState,
} from 'react';
import { Blob, Buffer } from 'buffer';
import { log } from 'util';

const PlayerContainer = styled(Box)(({ theme }) => ({}));

interface Props {
	src: string;
}

export default function AudioPlayer({ src }: Props) {
	const audioRef = useRef(new Audio());
	const [currentTime, setCurrentTime] = useState(0);
	const [maxTime, setMaxTime] = useState(0);
	const [isPlaying, setIsPlaying] = useState(false);
	const [isError, setIsError] = useState(false);

	const onToggle = () => {
		const audio = audioRef.current;
		const newIsPlaying = !isPlaying;

		if (!audio) {
			return;
		}

		setIsPlaying(newIsPlaying);

		if (newIsPlaying) {
			audio.play();
			return;
		}

		audio.pause();
	};

	const onEnded: ReactEventHandler<HTMLAudioElement> = (event) => {
		const audio = audioRef.current;

		setCurrentTime(0);
		setIsPlaying(false);
		audio.pause();
	};

	const onTimeUpdate: ReactEventHandler<HTMLAudioElement> = (event) => {
		const audio = audioRef.current;

		setCurrentTime(audio.currentTime);
	};

	const onLoad: ReactEventHandler<HTMLAudioElement> = (event) => {
		const audio = audioRef.current;

		setMaxTime(audio.duration);
	};
	console.log(maxTime);

	return (
		<PlayerContainer>
			<audio
				ref={audioRef}
				onTimeUpdate={onTimeUpdate}
				onEnded={onEnded}
				onLoadedMetadata={onLoad}
			>
				<source src={src} type="audio/wav" />
			</audio>
			<Stack direction="row" alignItems="center" spacing={1}>
				<IconButton onClick={onToggle}>
					{isPlaying ? <Pause /> : <PlayArrow />}
				</IconButton>

				<Slider
					size="small"
					value={currentTime}
					max={maxTime}
					onChange={(event, value) => {
						if (typeof value === 'number') {
							setCurrentTime(value);
							audioRef.current.currentTime = value;
						}
					}}
				/>
			</Stack>
		</PlayerContainer>
	);
}
